import { authReducer } from "./auth.reducer";
import { userReducer } from "./user.reducer";
import { homeReducer } from "./home.reducer";
import { adminReducer } from "./admin.reducer";
import { agentReducer } from "./agent.reducer";
import { systemReducer } from "./system.reducer";
import { countryReducer } from "./country.reducer";
import { propertyReducer } from "./property.reducer";
import { subscriptionReducer } from "./subscription.reducer";
import { paymentHistoryReducer } from "./paymentHistory.reducer";
import { privacyPolicyReducer } from "./privacyPolicy.reducer";
import { termsAndConditionsReducer } from "./termsAndConditions.reducer";
import { countriesEncyclopediaReducer } from "./countriesEncyclopedia.reducer";

const allReducers = {
  homeReducer,
  authReducer,
  userReducer,
  adminReducer,
  agentReducer,
  systemReducer,
  countryReducer,
  propertyReducer,
  subscriptionReducer,
  paymentHistoryReducer,
  privacyPolicyReducer,
  termsAndConditionsReducer,
  countriesEncyclopediaReducer,
};

export default allReducers;
